import { axios } from '@/lib/axios/axios';
import { MESSAGING_API_BASE } from '../config';

export type RequestUploadBody = {
  fileName: string;
  contentType: string;
  sizeInBytes: number;
};

export type RequestUploadResponse = {
  presignedUrl: string;
  s3Key: string;
};

export const requestUpload = async (
  body: RequestUploadBody
): Promise<RequestUploadResponse> => {
  // Backend expects hyphenated property names (e.g. 'file-name')
  const payload = {
    'file-name': body.fileName,
    'content-type': body.contentType,
    'size-in-bytes': body.sizeInBytes,
  } as any;

  return axios.post(`${MESSAGING_API_BASE}/files/request-upload`, payload);
};

export const useRequestUpload = () => {
  return { requestUpload };
};
